import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    color: {
        color: '#fff',
    },
    title: {
        fontFamily: 'PT-sans, sans-serif', 
        marginBottom: 20
    },
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
        width: '410px'
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '32%', 
    },
    textarea: {
        color: '#fff',
        background: '#1c2542',
        border: 0,
        borderRadius: '4px',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        padding: '6px',
        minWidth: '40px',
        width: '410px',
        height: '140px',
        resize: 'none',
        outline: 'none'
    },
    selectList: {
        width: '420px', 
        minHeight: '30px',
        background: '#1a1c35',
        border: '1px solid #24263e',
        boxSizing: 'border-box',
        borderRadius: '4px',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative',
        paddingRight: '25px',
    },
    selectItem: {
        height: 25, 
        display: 'flex', 
        alignItems: 'center',
        background: 'rgba(0,163,249,.1)',
        borderRadius: '2px',
        padding: '3px 10px',
        margin: '3px',
        fontSize: '16px',
        lineHeight: '25px',
        color: '#00a3f9',
    },
    select: {
        border: 0,
        background: '#293356',
        boxShadow: 'inset 0 1px 0 0 hsl(0deg 0% 100% / 20%)',
        paddingLeft: 8,
        borderRadius: '4px',
        color: '#fff',
        cursor: 'pointer',
        display: 'table',
        borderSpacing: 0,
        borderCollapse: 'initial',
        height: '32px',
        outline: 'none',
        overflow: 'hidden',
        position: 'relative',
        width: '420px'
    },
    btn: {
        fontSize: '14px',
        lineHeight: '19px',
        fontWeight: 700,
        textAlign: 'center',
        letterSpacing: '.5px',
        textTransform: 'uppercase',
        color: '#24263e',
        background: '#00a3f9',
        border: '1px solid #00a3f9',
        padding: '5px 12px',
        borderRadius: 4,
        cursor: 'pointer',
        userSelect: 'none'
    }
}))

export {
    useStyles
}